var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogowhatsappIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logowhatsapp-icon_svg__clip0_1_1242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.339 7.904c0 1.345.35 2.657 1.019 3.814L.275 15.671l4.045-1.06a7.627 7.627 0 003.647.928h.003c4.206 0 7.63-3.422 7.631-7.629a7.581 7.581 0 00-2.233-5.397A7.583 7.583 0 007.97.276C3.764.276.34 3.698.339 7.904",
    fill: "url(#logowhatsapp-icon_svg__paint0_linear_1_1242)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.066 7.902c0 1.392.364 2.752 1.055 3.95L0 15.947l4.19-1.099a7.901 7.901 0 003.778.962h.003c4.357 0 7.903-3.545 7.905-7.902 0-2.111-.82-4.097-2.313-5.59A7.855 7.855 0 007.97 0C3.614 0 .068 3.545.066 7.902zm2.496 3.744l-.157-.248a6.55 6.55 0 01-1.004-3.496 6.579 6.579 0 016.573-6.567c1.755 0 3.404.684 4.645 1.926a6.528 6.528 0 011.922 4.647 6.579 6.579 0 01-6.57 6.568H7.97a6.563 6.563 0 01-3.344-.916l-.24-.142-2.487.652.664-2.424z",
    fill: "url(#logowhatsapp-icon_svg__paint1_linear_1_1242)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.996 4.598c-.148-.329-.304-.335-.445-.341-.115-.005-.247-.005-.378-.005a.726.726 0 00-.527.248c-.181.197-.691.675-.691 1.647 0 .971.707 1.91.806 2.043.099.131 1.366 2.19 3.374 2.98 1.668.659 2.008.528 2.37.495.362-.033 1.169-.478 1.333-.939.165-.461.165-.856.116-.939-.05-.082-.182-.132-.38-.23-.197-.1-1.168-.577-1.349-.643-.18-.066-.312-.099-.444.099-.132.197-.51.642-.625.774-.116.132-.23.148-.428.05-.198-.1-.834-.308-1.589-.98A5.95 5.95 0 016.04 7.488c-.115-.198-.012-.305.087-.403.089-.089.198-.23.297-.346.098-.116.131-.198.197-.33.066-.131.033-.247-.017-.346-.049-.098-.433-1.075-.608-1.466z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logowhatsapp-icon_svg__paint0_linear_1_1242",
    x1: 766.579,
    y1: 1539.78,
    x2: 766.579,
    y2: 0.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logowhatsapp-icon_svg__paint1_linear_1_1242",
    x1: 793.798,
    y1: 1594.71,
    x2: 793.798,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "logowhatsapp-icon_svg__clip0_1_1242"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h15.876v16H0z"
  })))));
}
export default SvgLogowhatsappIcon;